// Development
// const apiURL = 'http://127.0.0.1:2638/api'
// Deployment
 const apiURL = '/api'

export const globals = {
    apiURL
}